import React from "react";

const TABLE_PATTERN = /\[TABLE:\s*([\s\S]*?)\]/gi;

const cleanPlainText = (value) =>
  String(value ?? "")
    .replace(/\[IMAGE:\s*[^\]]+\]/gi, "")
    .replace(/â€”/g, "—")
    .replace(/â€¢/g, "•")
    .replace(/[ \t]{2,}/g, " ")
    .trim();

const parseTable = (body) =>
  String(body)
    .split(";")
    .map((row) => row.split("|").map((cell) => cell.trim()))
    .filter((row) => row.some(Boolean));

export const splitQuestionContent = (value) => {
  const text = String(value ?? "").replace(/\[IMAGE:\s*[^\]]+\]/gi, "");
  const parts = [];
  let lastIndex = 0;
  TABLE_PATTERN.lastIndex = 0;
  let match = TABLE_PATTERN.exec(text);
  while (match) {
    if (match.index > lastIndex) {
      const plain = cleanPlainText(text.slice(lastIndex, match.index));
      if (plain) parts.push({ type: "text", value: plain });
    }
    const rows = parseTable(match[1]);
    if (rows.length) parts.push({ type: "table", rows });
    lastIndex = match.index + match[0].length;
    match = TABLE_PATTERN.exec(text);
  }
  const tail = cleanPlainText(text.slice(lastIndex));
  if (tail) parts.push({ type: "text", value: tail });
  return parts;
};

const tableWrapStyle = {
  overflowX: "auto",
  margin: "12px 0",
  WebkitOverflowScrolling: "touch",
};

const tableStyle = {
  borderCollapse: "collapse",
  width: "100%",
  minWidth: "280px",
  fontSize: "14px",
  lineHeight: 1.4,
  background: "#fff",
};

const cellStyle = {
  border: "1px solid #D5DEEA",
  padding: "8px 10px",
  textAlign: "left",
  verticalAlign: "top",
  whiteSpace: "normal",
};

const headerStyle = {
  ...cellStyle,
  background: "#F4F7FB",
  fontWeight: 700,
  color: "#0D355C",
};

const QuestionTable = ({ rows }) => {
  const [header, ...body] = rows;
  return (
    <div style={tableWrapStyle}>
      <table style={tableStyle}>
        <thead>
          <tr>
            {header.map((cell, index) => (
              <th key={index} style={headerStyle}>{cell || "\u00a0"}</th>
            ))}
          </tr>
        </thead>
        <tbody>
          {body.map((row, rowIndex) => (
            <tr key={rowIndex}>
              {row.map((cell, cellIndex) => (
                <td key={cellIndex} style={cellStyle}>{cell || "\u00a0"}</td>
              ))}
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};

const QuestionBody = ({ text }) => {
  const parts = splitQuestionContent(text);
  if (!parts.length) return null;
  return (
    <>
      {parts.map((part, index) =>
        part.type === "table" ? (
          <QuestionTable key={index} rows={part.rows} />
        ) : (
          <span key={index} style={{ whiteSpace: "pre-wrap" }}>{part.value} </span>
        )
      )}
    </>
  );
};

export default QuestionBody;
